import {Trans} from '@ui/i18n/trans';

export function TrustedMusicCopyright({
  breakBeforeRightsReserved = false,
  showSellerLabel = true,
}: {
  breakBeforeRightsReserved?: boolean;
  showSellerLabel?: boolean;
}) {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <div>
        {breakBeforeRightsReserved ? (
          <>
            TrustedMusic © {currentYear}.
            <br />
            <Trans message="All rights reserved." />
          </>
        ) : (
          <Trans
            message="TrustedMusic © :year. All rights reserved."
            values={{year: currentYear}}
          />
        )}
      </div>
      <div className="mt-2">
        {showSellerLabel ? 'Sprzedawca: ' : null}MARE AMBRA · NIP 6040067628
      </div>
    </div>
  );
}
